import { Box, Flex, Heading, HStack, Icon, Text, VStack } from "@chakra-ui/react";
import React from "react";
import { PiQuestionDuotone as FiHelpCircle, PiInfoDuotone as FiInfo, PiEnvelopeSimpleDuotone as FiMail } from "react-icons/pi";
import { drgba } from "../../../components/glassUi";

type Tip = { h: string; t: string };
type TipBlock = { title: string; items: Tip[] };

const TIPS: Record<string, TipBlock> = {
  type: {
    title: "Typ głosowania",
    items: [
      { h: "Widoczność", t: "Domyślnie niepubliczne — temat, pytania i wyniki zna tylko zaproszony krąg. Jawne — temat, pytania ORAZ wyniki widzą wszyscy (też spoza głosowania); głosować mogą tylko uprawnieni." },
      { h: "Tajność", t: "Tajne — nikt nie zobaczy, jak zagłosowałeś (domyślne). Jawne imienne — głos każdej osoby jest widoczny, jak w radzie miasta." },
      { h: "Weryfikacja", t: "Domyślnie bez weryfikacji (dla znanych list). Tylko zweryfikowani — udział wymaga potwierdzonej tożsamości (mObywatel); referendum otwarte włącza ją automatycznie." },
      { h: "Potwierdzanie głosu", t: "W sesji (zalecane) — zalogowany potwierdza od razu, bez maila. Mail lub aplikacja — push w apce z kaskadą na e-mail. Tylko aplikacja — wyłącznie push, jak 2FA bankowe. Osoby bez konta zawsze potwierdzają mailem." }
    ]
  },
  data: {
    title: "Dane głosowania",
    items: [
      { h: "Tytuł", t: "Konkretny i jednoznaczny — to pierwsze, co zobaczy głosujący." },
      { h: "Daty", t: "Start musi być w przyszłości; zaproszenia wychodzą w dniu startu. Koniec wyznacza moment liczenia wyniku i zapisu na blockchain — później nie zmienisz." },
      { h: "Szybkie presety", t: "Skorzystaj z gotowych skrótów: start (Za godzinę / Jutro 9:00 / Poniedziałek 9:00), a czas trwania (30 min … Tydzień) ustawia koniec względem startu." }
    ]
  },
  questions: {
    title: "Pytania",
    items: [
      { h: "TAK / NIE", t: "Dla uchwał — wynik liczony względem progu przyjęcia." },
      { h: "Jednokrotny wybór", t: "Jedna odpowiedź z listy; zwycięża opcja z największą liczbą głosów." },
      { h: "Wielokrotny wybór", t: "Głosujący wybiera kilka opcji (do ustalonego limitu)." },
      { h: "Zasada rozstrzygnięcia", t: "Przy każdym pytaniu ustalasz próg: dla TAK/NIE % na TAK, dla wyborów zwykła większość lub wymagany próg." }
    ]
  },
  voters: {
    title: "Kto może głosować",
    items: [
      { h: "Zamknięta lista", t: "Znani uprawnieni — z grup, CSV lub ręcznie. Ręcznie możesz wkleić wiele adresów naraz (przecinek/spacja/enter); źródła łączą się, duplikaty znikają." },
      { h: "Zapisy (vox populi)", t: "Publiczny link do zapisów; termin zamknięcia proponujemy względem startu głosowania (np. godzinę przed). Po zamknięciu lista staje się elektoratem." },
      { h: "Otwarte (referendum)", t: "Bez listy — głosuje każdy zweryfikowany przez mObywatel. Weryfikacja obowiązkowa." }
    ]
  },
  rules: {
    title: "Zasady i dokumenty",
    items: [
      { h: "Kworum", t: "Minimalna frekwencja, by całe głosowanie było ważne (np. ≥50% uprawnionych). Puste = brak kworum." },
      { h: "Próg przyjęcia", t: "Ustawiasz osobno przy każdym pytaniu (krok Pytania) — inny dla TAK/NIE, jednego i wielu wyborów." },
      { h: "Wstrzymania", t: "Wliczają się do frekwencji/kworum, ale nie do progu przyjęcia." },
      { h: "Dokumenty (opcjonalnie)", t: "Możesz wgrać własny regulamin i politykę prywatności (PDF) do akceptacji przez uczestników. Pominięte = używamy dokumentów platformy." }
    ]
  }
};

export const TipsSidebar: React.FC<{ stepKey: string; extra?: React.ReactNode }> = ({ stepKey, extra }) => {
  const block = TIPS[stepKey];

  return (
    <Box>
      {extra}
      {block && (
        <Box mt={extra ? "16px" : 0}>
          <HStack spacing="8px" mb="6px">
            <Icon as={FiHelpCircle} color="accent" boxSize="18px" />
            <Text fontSize="12px" fontWeight="800" textTransform="uppercase" letterSpacing="0.08em" color="#5a5468">
              Wskazówki
            </Text>
          </HStack>
          <Heading fontSize="16px" color="#241536" mb="14px" letterSpacing="-0.01em">
            {block.title}
          </Heading>
          <VStack align="stretch" spacing="14px">
            {block.items.map(item => (
              <HStack key={item.h} align="flex-start" spacing="10px">
                <Icon as={FiInfo} color="primary" boxSize="15px" mt="2px" flexShrink={0} />
                <Box>
                  <Text fontSize="14px" fontWeight="700" color="primary">
                    {item.h}
                  </Text>
                  <Text fontSize="13px" color="gray.500" lineHeight="1.5">
                    {item.t}
                  </Text>
                </Box>
              </HStack>
            ))}
          </VStack>
        </Box>
      )}

      <Flex mt="18px" bg={drgba("#430098", 0.05)} borderRadius="16px" p="16px" gap="12px" align="flex-start">
        <Icon as={FiMail} color="primary" boxSize="18px" mt="2px" />
        <Box>
          <Text fontSize="14px" fontWeight="800" color="#241536">
            Potrzebujesz pomocy?
          </Text>
          <Text fontSize="13px" color="#6b6480">
            Napisz na kontakt@lubbezposrednio.pl
          </Text>
        </Box>
      </Flex>
    </Box>
  );
};
